// Harvey Mudd College's majors (#2739). Read on 2026-10-01 from the official
// Harvey Mudd College Catalog 2026-2027 (catalog.hmc.edu), Programs of Study:
// the Programs list on each department page, the Interdisciplinary Majors page
// and the Other Programs page. Harvey Mudd awards the bachelor of science. The
// catalog lists the Biology and Physics options as separate programs, so they
// are listed as written; "Chemistry Major" is shown as Chemistry. Each joint
// major appears once, under Interdisciplinary majors. Minors (open only to
// students with an off-campus major), the off-campus major at another
// Claremont College, the Data Science and Environmental Analysis emphases, the
// 3-2 dual degree programs and the Claremont Graduate University accelerated
// master's programs are left out. The Department of Humanities, Social
// Sciences, and the Arts lists no major.
const majors = {
    "slug": "harvey-mudd-college",
    "read": "2026-10-01",
    "intro": "Every major in Harvey Mudd's official 2026-2027 Catalog, including its joint majors and the options within Biology and Physics, each leading to the bachelor of science. Minors, emphases and dual degree programs are left out.",
    "groups": [
        {
            "name": "Biology",
            "source": {
                "label": "Harvey Mudd Catalog 2026-2027, Department of Biology",
                "url": "https://catalog.hmc.edu/preview_entity.php?catoid=28&ent_oid=257"
            },
            "majors": [
                {
                    "name": "Biology, General Option",
                    "degree": "B.S."
                },
                {
                    "name": "Biology, Molecular Biology Option",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Chemistry",
            "source": {
                "label": "Harvey Mudd Catalog 2026-2027, Department of Chemistry",
                "url": "https://catalog.hmc.edu/preview_entity.php?catoid=28&ent_oid=258"
            },
            "majors": [
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Computer Science",
            "source": {
                "label": "Harvey Mudd Catalog 2026-2027, Department of Computer Science",
                "url": "https://catalog.hmc.edu/preview_entity.php?catoid=28&ent_oid=259"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Engineering",
            "source": {
                "label": "Harvey Mudd Catalog 2026-2027, Department of Engineering",
                "url": "https://catalog.hmc.edu/preview_entity.php?catoid=28&ent_oid=260"
            },
            "majors": [
                {
                    "name": "Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Mathematics",
            "source": {
                "label": "Harvey Mudd Catalog 2026-2027, Department of Mathematics",
                "url": "https://catalog.hmc.edu/preview_entity.php?catoid=28&ent_oid=262"
            },
            "majors": [
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Physics",
            "source": {
                "label": "Harvey Mudd Catalog 2026-2027, Department of Physics",
                "url": "https://catalog.hmc.edu/preview_entity.php?catoid=28&ent_oid=263"
            },
            "majors": [
                {
                    "name": "Physics, Applied Physics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Physics, Astrophysics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Physics, Biophysics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Physics, Chemical Physics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Physics, Computational Physics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Physics, Education Option",
                    "degree": "B.S."
                },
                {
                    "name": "Physics, Geophysics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Physics, Mathematical Physics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Physics, Standard Program",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Interdisciplinary majors",
            "source": {
                "label": "Harvey Mudd Catalog 2026-2027, Interdisciplinary Majors",
                "url": "https://catalog.hmc.edu/preview_entity.php?catoid=28&ent_oid=264"
            },
            "majors": [
                {
                    "name": "Joint Major in Biology and Climate",
                    "degree": "B.S."
                },
                {
                    "name": "Joint Major in Chemistry and Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Joint Major in Chemistry and Climate",
                    "degree": "B.S."
                },
                {
                    "name": "Joint Major in Computer Science and Climate",
                    "degree": "B.S."
                },
                {
                    "name": "Joint Major in Computer Science and Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Joint Major in Computer Science and Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Joint Major in Mathematics and Climate",
                    "degree": "B.S."
                },
                {
                    "name": "Joint Major in Mathematics and Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematical and Computational Biology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Student-designed major",
            "source": {
                "label": "Harvey Mudd Catalog 2026-2027, Other Programs",
                "url": "https://catalog.hmc.edu/preview_entity.php?catoid=28&ent_oid=265"
            },
            "majors": [
                {
                    "name": "Individual Program of Studies",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
